/**
 * program
 * Program APIs
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProgramActionMngDtoActionData } from './programActionMngDtoActionData';
import { ProgramActionMngDtoContent } from './programActionMngDtoContent';


export interface ProgramActionMngDto { 
    /**
     * The action identifier that uniquely identifies the action type. The action identifier is a part of the payload when executing an action.
     */
    actionId: string;
    /**
     * The action display name.
     */
    label: { [key: string]: string; };
    /**
     * The icon identifier to be displayed next to the action.
     */
    icon: string;
    /**
     * The appearance of action. It affects the way how the action is displayed (coloring scheme, highlight...)
     */
    appearance: ProgramActionMngDto.AppearanceEnum;
    /**
     * The type of action. Depending on the type, different actions may occur - opening a link, showing a modal dialog...
     */
    actionType: ProgramActionMngDto.ActionTypeEnum;
    /**
     * The sub type of action. Further describes the expected UI and activity.
     */
    actionSubType?: ProgramActionMngDto.ActionSubTypeEnum;
    content: ProgramActionMngDtoContent;
    actionData?: ProgramActionMngDtoActionData;
    /**
     * The value indicating if program needs to be refreshed after executing the action. The action changes the state of the program.
     */
    requiresRefresh: ProgramActionMngDto.RequiresRefreshEnum;
}
export namespace ProgramActionMngDto {
    export type AppearanceEnum = 'normal' | 'destructive';
    export const AppearanceEnum = {
        Normal: 'normal' as AppearanceEnum,
        Destructive: 'destructive' as AppearanceEnum
    };
    export type ActionTypeEnum = 'link' | 'modal' | 'invoke';
    export const ActionTypeEnum = {
        Link: 'link' as ActionTypeEnum,
        Modal: 'modal' as ActionTypeEnum,
        Invoke: 'invoke' as ActionTypeEnum
    };
    export type ActionSubTypeEnum = 'revspringIFrame' | 'dialogSendLink' | 'dialogCancelSubscription' | 'dialogCompleteCheckIn' | 'dialogCompleteIntake' | 'dialogUpdateShippingAddress' | 'dialogScheduleConsultation' | 'dialogCancelConsultation' | 'dialogCompleteAggregate' | 'dialogActivateProgram';
    export const ActionSubTypeEnum = {
        RevspringIFrame: 'revspringIFrame' as ActionSubTypeEnum,
        DialogSendLink: 'dialogSendLink' as ActionSubTypeEnum,
        DialogCancelSubscription: 'dialogCancelSubscription' as ActionSubTypeEnum,
        DialogCompleteCheckIn: 'dialogCompleteCheckIn' as ActionSubTypeEnum,
        DialogCompleteIntake: 'dialogCompleteIntake' as ActionSubTypeEnum,
        DialogUpdateShippingAddress: 'dialogUpdateShippingAddress' as ActionSubTypeEnum,
        DialogScheduleConsultation: 'dialogScheduleConsultation' as ActionSubTypeEnum,
        DialogCancelConsultation: 'dialogCancelConsultation' as ActionSubTypeEnum,
        DialogCompleteAggregate: 'dialogCompleteAggregate' as ActionSubTypeEnum,
        DialogActivateProgram: 'dialogActivateProgram' as ActionSubTypeEnum
    };
    export type RequiresRefreshEnum = 'noRefresh' | 'programRefresh' | 'pageRefresh';
    export const RequiresRefreshEnum = {
        NoRefresh: 'noRefresh' as RequiresRefreshEnum,
        ProgramRefresh: 'programRefresh' as RequiresRefreshEnum,
        PageRefresh: 'pageRefresh' as RequiresRefreshEnum
    };
}


